import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router";
import { useAuth } from "../context/useAuth";
import { useTranslation } from "react-i18next";
import "../styles/NavBar.css";

export default function NavbarComp() {
    const [t, i18n] = useTranslation("global");
    const navigate = useNavigate();
    const { logout, logedIsAdmin } = useAuth();
    const handleLanguageChange = (selectedLanguage: string) => {
        i18n.changeLanguage(selectedLanguage);
    };
    return (
        <>
            <Navbar
                className="navbar-custom py-4"
                bg="light"
                data-bs-theme="light"
            >
                <Container>
                    <Nav>
                        <Nav.Link onClick={() => navigate("/")}>
                            {t("navbar.home")}
                        </Nav.Link>
                        <Nav.Link onClick={() => navigate("/form")}>
                            {t("navbar.form")}
                        </Nav.Link>
                        <Nav.Link onClick={() => navigate("/from-file")}>
                            {t("navbar.fromcsv")}
                        </Nav.Link>

                        {logedIsAdmin() && (
                            <Nav.Link onClick={() => navigate("/upload-model")}>
                                {t("navbar.uploadpipeline")}
                            </Nav.Link>
                        )}

                        <Nav.Link onClick={logout}>
                            {t("navbar.logout")}
                        </Nav.Link>
                    </Nav>
                    <Nav>
                        <NavDropdown
                            title={t("navbar.language")}
                            id="basic-nav-dropdown"
                            onSelect={handleLanguageChange}
                        >
                            <NavDropdown.Item eventKey="en">
                                {t("navbar.languages.en")}
                            </NavDropdown.Item>
                            <NavDropdown.Item eventKey="es">
                                {t("navbar.languages.es")}
                            </NavDropdown.Item>
                            <NavDropdown.Item eventKey="cat">
                                {t("navbar.languages.cat")}
                            </NavDropdown.Item>
                        </NavDropdown>
                    </Nav>
                </Container>
            </Navbar>
        </>
    );
}
